export default [
    {
        path: '/warehouse/shipping',
        name: 'shipping',
        props: true,
        component: () => import('@/views/warehouse/shipping/index.vue'),
        meta: {
            pageTitle: 'Shipping',
            breadcrumb: [
                {
                text: 'Shipping',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/shipping/:id',
        name: 'detail-shipping',
        props: true,
        component: () => import('@/views/warehouse/shipping/detail.vue'),
        meta: {
            pageTitle: 'Detail Shipping',
            breadcrumb: [
                {
                text: 'Shipping',
                to: { name: 'shipping' },
                },
                {
                text: 'Detail Shipping',
                active: true,
                },
            ],
        },
    },
]